package org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class CustomerCardTypeEnum {
    IN_HOUSE,
    LOYALTY_CARDS,
    DEBIT_CARDS;

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            IN_HOUSE -> strings.inHouseCard
            LOYALTY_CARDS -> strings.loyaltyCard
            DEBIT_CARDS -> strings.debitCard
        }
    }

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                IN_HOUSE -> strings.inHouseCard
                LOYALTY_CARDS -> strings.loyaltyCard
                DEBIT_CARDS -> strings.debitCard
            }
        }

    val value: Int
        get() = when (this) {
            IN_HOUSE -> 1
            LOYALTY_CARDS -> 2
            DEBIT_CARDS -> 3
        }
}